import { useContext } from 'react';

import SessionContext from './SessionContext';
import { SessionContextType } from './model';

export default (): SessionContextType => {
  return useContext(SessionContext);
};
